"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleableTextarea = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var editable_textarea_1 = require("../editable-textarea");
function ToggleableTextarea(_a) {
    var children = _a.children, onSave = _a.onSave, onCancel = _a.onCancel, textareaProps = (0, tslib_1.__rest)(_a, ["children", "onSave", "onCancel"]);
    var _b = (0, react_1.useState)(false), isEditing = _b[0], setIsEditing = _b[1];
    function toggle() {
        setIsEditing(function (currentIsEditing) { return !currentIsEditing; });
    }
    if (!isEditing) {
        return children({
            toggle: toggle,
            isEditing: isEditing,
        });
    }
    return (react_1.default.createElement(editable_textarea_1.EditableTextarea, (0, tslib_1.__assign)({ autoFocus: true, onCancel: function () {
            toggle();
            onCancel === null || onCancel === void 0 ? void 0 : onCancel();
        }, onSave: function (value) {
            toggle();
            onSave(value);
        } }, textareaProps)));
}
exports.ToggleableTextarea = ToggleableTextarea;
//# sourceMappingURL=index.js.map